import React, { Component } from 'react';
import { Grid, Divider, Tab } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import Route from './tabs/route-tab';
import ProjectInfo from './tabs/cons-planning/project-info';
import PublicImpacts from './tabs/cons-planning/public-impacts';
import Finance from './tabs/cons-planning/finance';
import Detour from './tabs/cons-planning/detour';
import '../index.css';
import { Button } from '@blueprintjs/core';

export default class ConstructionPlanning extends Component {

    constructor(props)
    {
        super(props);
        if (this.props.loadData) {
            this.state = {
                ConstructionPlanning: this.props.loadData                
            };
        }
        else {
            // This is a super data model class, its main function is to collect data from all the children components.
            this.state = {
                ConstructionPlanning: {
                    layer: 4,
                    layerName: 'ConstructionPlanning',
                    layerId: -1,
                    agencyId: -1, //to be determined later

                    route: {
                        id: -1, //id is not set, will be setting it soon.
                        start: '0,0',
                        end: '0,0',
                        isPolyLine: false,
                        waypoints: [],
                        routeLine: null,
                        hwyNum: "",
                        segDesc: ""
                    },

                    projectInfo: {
                        type: 0,
                        surfacing: 0,
                        thickness: 0.00,
                        bridgeType: 0,
                        rehabType: 0,
                        maintType: 0,
                        safetyType: 0,
                        emergencyType: 0,
                        description: "",
                        projectNumber: "",
                        plannedYear: "0",
                        projectStatus: 0,
                        projectStatusDate: null,
                        bidOpeningDate: null,
                        estimatedTotalCost: 0.00,
                        finalTotalCost: 0.00,
                        length: 0.00,
                        owner: 0
                    },

                    publicImpacts: {
                        actualConsStart: null,
                        actualConsEnd: null,
                        publicImpact: 0,
                        widthRes: 0,
                        impactNotice: null,
                        detourLength: 0,
                        comment: ""
                    },

                    finance: {
                        fundingSource: 0,
                        percent: 0,
                        committed: 0,
                        fundingSource2: 0,
                        percent2: 0,
                        committed2: 0,
                        fundingSource3: 0,
                        percent3: 0,
                        committed3: 0,
                        fundingSource4: 0,
                        percent4: 0,
                        committed4: 0,
                        fundingSource5: 0,
                        percent5: 0,
                        committed5: 0,
                    },
                    detourRoute: {
                        DetourStart: '0,0',
                        DetourEnd: '0,0',
                        DetourIsPolyLine: false,
                        DetourWaypoints: [],
                        DetourDescription: "",
                        DetourRouteLine: null

                    },
                }
            };
        }
      

        this.panes = [
            {
                menuItem: 'Location', render: () =>
                    <Tab.Pane>
                        <Route clickFunctions={this.props.clickFunctions}
                            trackLocationChanged={this.props.isLocationChanged}
                            triggerNeedSave={this.props.triggerNeedSave}
                            disabled={this.props.disabled}
                            routeModel={this.state.ConstructionPlanning.route} />
                    </Tab.Pane>
            },
            {
                menuItem: 'Project Info', render: () =>
                    <Tab.Pane>
                        <ProjectInfo triggerNeedSave={this.props.triggerNeedSave}
                            disabled={this.props.disabled}
                            cpModel={this.state.ConstructionPlanning} />
                    </Tab.Pane>
            },
            {
                menuItem: 'Public Impacts', render: () =>
                    <Tab.Pane>
                        <PublicImpacts triggerNeedSave={this.props.triggerNeedSave}
                            disabled={this.props.disabled}
                            cpModel={this.state.ConstructionPlanning} />
                    </Tab.Pane>
            },
            {
                menuItem: 'Finance', render: () =>
                    <Tab.Pane>
                        <Finance triggerNeedSave={this.props.triggerNeedSave}
                            disabled={this.props.disabled}
                            cpModel={this.state.ConstructionPlanning} />
                    </Tab.Pane>
            },
            {
                menuItem: 'Detour', render: () =>
                    <Tab.Pane>
                        <Detour cpModel={this.state.ConstructionPlanning}
                        triggerNeedSave={this.props.triggerNeedSave}
                        disabled={this.props.disabled} 
                        clickFunctions={this.props.clickFunctions}
                        trackLocationChanged={this.props.isLocationChanged}                     
                        getroutes = {this.props.getroutes}
                        showspinner = {this.props.showSpinner}
                        />
                    </Tab.Pane>
            }
        ];

        this.props.dataModel.splice(0, this.props.dataModel.length);
        this.props.dataModel.push(this.state.ConstructionPlanning);
    }

   

    renderGritLayerUI = () => {
        return (
            <div>
                {/* <Grid.Row>
                    <h5>Construction Planning</h5>
                </Grid.Row> */}
                <Divider style={{ marginTop: -3 }} />
                <Grid.Row>
                    <Tab panes={this.panes} activeIndex={this.props.activeIndex} onTabChange={this.onTabChange}/>
                </Grid.Row>
              
            </div>
        );
    }

    onTabChange = (e, data) => {
        this.props.updateActiveIndex(data.activeIndex);
    }

    render() {
        return this.renderGritLayerUI();
    }
}


// WEBPACK FOOTER //
// ./src/layers/cons-planning.js